<div class="rounded-xl">
  <div class="flexable flex gap-2 p-2">
    <div
      class="flex gap-1 items-center rounded-tab w-fit p-2"
      *ngIf="isAllWarehouse"
    >
      <span class="text-black">Warehouse: </span>
      <div>
        <select
          name=""
          id=""
          [(ngModel)]="filtering.warehouse"
          (change)="onFilterChange(null, 'warehouse')"
        >
          <option value="" selected>All</option>
          @for (warehouse of warehouses$ | async; track warehouse) {
          <option value="{{ warehouse?.uniqueId }}">
            {{ warehouse?.name }}
          </option>
          }
        </select>
      </div>
    </div>
    <div
  class="flex gap-1 items-center rounded-tab w-fit p-2"
  *ngIf="filtering.warehouse"
>
  <span class="text-black">Sensor:</span>

  <select [(ngModel)]="filtering.sensor">
    <option value="">Select sensor</option>

    @for (sensor of warehouseSensors$ | async; track sensor) {
      <option [value]="sensor.uniqueId">
        {{ sensor.sensorName }}
      </option>
    }
  </select>

  <div *ngIf="filtering.sensor">
    <span
      (click)="filtering.sensor = null"
      class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
    >
      <mat-icon class="scale-50">clear</mat-icon> Clear
    </span>
  </div>
</div>

    <div class="flex gap-4 items-center rounded-tab w-fit p-2">
      <span class="text-black">Timeframe: </span>
      <div class="flex items-center gap-1">
        @for (tab of timeframeTabs; track tab) { @if (tab?.name ===
        activeTimeframeTab) {
        <span
          class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
        >
          <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
        </span>
        } @else {
        <span
          (click)="
            activeTimeframeTab = tab?.name;
            onFilterChange(tab?.name, 'timeframe')
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
          >{{ tab?.name }}</span
        >
        } } @if (activeTimeframeTab) {
        <div
          (click)="
            activeTimeframeTab = null;
            filtering.dateTo = null;
            filtering.dateFrom = null
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8] !w-fit flex !min-w-[132px] gap-1"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
          <span>Custom Date</span>
        </div>
        } @else {
        <span
          class="!cursor-pointer !bg-[#3A7AA8] !px-[12px] rounded-full !py-[8px] !min-w-[132px] gap-1"
        >
          <span class="text-white !text-[13px]">
            <fa-icon [icon]="faCalendar"></fa-icon>
            Custom Date
          </span>
        </span>
        }
        <div
          class="flex gap-1"
          [ngStyle]="{ display: activeTimeframeTab ? 'none' : '' }"
        >
          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [max]="endDate"
              [(ngModel)]="startDate"
              (dateChange)="onFilterChange(null, 'dateFrom')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="startDatePicker"
              placeholder="Select Start Date"
              readonly
              (click)="startDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="startDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </div>
          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [(ngModel)]="endDate"
              [min]="startDate"
              (dateChange)="onFilterChange(null, 'dateTo')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="endDatePicker"
              placeholder="Select End Date"
              readonly
              (click)="endDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="endDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </div>
        </div>
      </div>
    </div>

    <div class="flex gap-4 items-center rounded-tab w-fit p-2">
      <span class="text-black">Frequency: </span>
      <div class="flex gap-1">
        @for (tab of frequencyTabs; track tab) { @if (tab?.name ===
        activeFrequencyTab) {
        <span
          class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
        >
          <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
        </span>
        } @else {
        <span
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
          (click)="
            activeFrequencyTab = tab?.name;
            onFilterChange(tab?.name, 'timeRange')
          "
          >{{ tab?.name }}
        </span>
        } }
      </div>
    </div>
  </div>

  <div class="flex justify-center pb-2">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal !bg-[#025590] !text-white">
      Generate
    </button>
  </div>
</div>

@if (reportData) {
<app-pdf-viewer
  *ngIf="reportData"
  class="w-full"
  [base64Src]="reportData"
  [filenameForDownload]="'coldroom-report'"
></app-pdf-viewer>
}
